module.exports = __webpack_public_path__ + "static/media/blender.5031bd83.svg";